import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';

const api = services.api;

// 商品类型筛选
export const ProductCategoryCodeSelect = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/attributes/optionsList';
        params = {
            ...params,
            attr_code: 'ZHPPL'
        };
        const response: any = await api.get(params, config);
        const result: any = [];
        response.map((item: any) => {
            result.push({
                id: item.code,
                name: item.optionValue
            });
        })
        return result;
    },
};
